import { render, staticRenderFns } from "./ConferenceFilter.vue?vue&type=template&id=537acc74&scoped=true&"
import script from "./ConferenceFilter.vue?vue&type=script&lang=js&"
export * from "./ConferenceFilter.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceFilter.vue?vue&type=style&index=0&id=537acc74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537acc74",
  null
  
)

export default component.exports